export const APPS_PAGE_PATH = '/account/integration-settings/oauth2apps'
export const CUSTOM_INTEGRATIONS_BASE_PATH = '/account/integration-settings/custom-integrations'
export const CUSTOM_INTEGRATION_CREATE_PATH = `${CUSTOM_INTEGRATIONS_BASE_PATH}/new`

export const customIntegrationDetailsPath = (customIntegrationId: string, tab?: string): string =>
  `${CUSTOM_INTEGRATIONS_BASE_PATH}/${customIntegrationId}${tab ? `/${tab}` : ''}`

export const customIntegrationCallbackPath = (customIntegrationId: string): string => `/integrations/callback/custom/${customIntegrationId}`

export const CUSTOM_INTEGRATION_USER_INTEGRATION_TYPE = 'custom_integration'

export const CUSTOM_INTEGRATION_LIST_SCOPE = 'custom_integration:list'
export const CUSTOM_INTEGRATION_CREATE_SCOPE = 'custom_integration:create'
export const CUSTOM_INTEGRATION_UPDATE_SCOPE = 'custom_integration:update'
export const CUSTOM_INTEGRATION_DELETE_SCOPE = 'custom_integration:delete'
export const CUSTOM_INTEGRATION_ADMIN_SCOPE = 'custom_integration:admin'

export const CUSTOM_INTEGRATION_QUOTA = 'integration.customEnabled.value'

export const CUSTOM_INTEGRATIONS_FEATURE_ENABLED = false
export const OAUTH2_APPS_QUOTA = 'integration.oauth2Enabled.value'
